import { render, staticRenderFns } from "./PhilosophyListing.vue?vue&type=template&id=a42a05e2&"
import script from "./PhilosophyListing.vue?vue&type=script&lang=js&"
export * from "./PhilosophyListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports